/* Peach Perfect – Shop-Funktionen (ohne Fremdbibliotheken) */
(() => {
  'use strict';

  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));
  const routes = window.fcRoutes || {};
  const strings = window.fcStrings || {};

  /* ---------- Geschützte E-Mail-Adressen erst im Browser zusammensetzen ---------- */
  function fcMail(enc) {
    try { return atob(enc).split('').reverse().join(''); } catch (e) { return ''; }
  }
  function revealMails(root = document) {
    $$('a[href^="#fc-m-"]', root).forEach((a) => {
      const m = fcMail(a.getAttribute('href').slice(6));
      if (m) a.setAttribute('href', 'mailto:' + m);
    });
    $$('.fc-em[data-e]', root).forEach((el) => {
      const m = fcMail(el.getAttribute('data-e'));
      if (!m) return;
      if (el.closest('a')) {
        el.textContent = m;
      } else {
        const a = document.createElement('a');
        a.href = 'mailto:' + m;
        a.textContent = m;
        el.replaceWith(a);
      }
      el.removeAttribute && el.removeAttribute('data-e');
    });
  }
  revealMails();

  /* ---------- Hinweis unten ---------- */
  let toastTimer;
  function toast(text) {
    let el = $('.fc-toast');
    if (!el) {
      el = document.createElement('div');
      el.className = 'fc-toast';
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      document.body.appendChild(el);
    }
    el.textContent = text;
    el.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => el.classList.remove('is-visible'), 2600);
  }

  /* ---------- Schubladen (Menü, Warenkorb) ---------- */
  let lastFocus = null;
  function openDrawer(id, ohneAuffrischen) {
    const drawer = document.getElementById(id);
    if (!drawer) return;
    if (!drawer.classList.contains('is-open')) lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    if (id === 'fc-cart-drawer') {
      if (!ohneAuffrischen && typeof refreshDrawer === 'function') refreshDrawer();
      loadDrawerReco();
      const bar = drawer.querySelector('[data-fc-bar]');
      if (bar && !bar.dataset.shown) {
        bar.dataset.shown = '1';
        const t = bar.getAttribute('data-fc-pct');
        bar.style.transition = 'none';
        bar.style.width = '0%';
        requestAnimationFrame(() => requestAnimationFrame(() => { bar.style.transition = ''; bar.style.width = t + '%'; }));
      }
    }
    document.body.classList.add('fc-lock');
    const focusable = drawer.querySelector('[data-fc-autofocus], button, a, input');
    if (focusable) setTimeout(() => focusable.focus(), 50);
  }
  function closeDrawer(drawer) {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    if (!$('.fc-drawer.is-open, .fc-search.is-open')) document.body.classList.remove('fc-lock');
    if (lastFocus && document.contains(lastFocus)) lastFocus.focus();
  }

  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-fc-open]');
    if (opener) {
      const target = opener.getAttribute('data-fc-open');
      if (target === 'fc-cart-drawer' && document.body.classList.contains('fc-template-cart')) return;
      e.preventDefault();
      if (target === 'fc-search') return openSearch();
      return openDrawer(target);
    }
    const closer = e.target.closest('[data-fc-close]');
    if (closer) {
      e.preventDefault();
      const box = closer.closest('.fc-drawer, .fc-search');
      if (box && box.classList.contains('fc-search')) return closeSearch();
      return closeDrawer(box);
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    const search = $('.fc-search.is-open');
    if (search) return closeSearch();
    const open = $('.fc-drawer.is-open');
    if (open) closeDrawer(open);
  });

  /* ---------- Suche mit Vorschlägen ---------- */
  function openSearch() {
    const box = $('#fc-search');
    if (!box) return;
    lastFocus = document.activeElement;
    box.classList.add('is-open');
    box.setAttribute('aria-hidden', 'false');
    document.body.classList.add('fc-lock');
    const input = $('input[type="search"]', box);
    if (input) setTimeout(() => input.focus(), 50);
  }
  function closeSearch() {
    const box = $('#fc-search');
    if (!box) return;
    box.classList.remove('is-open');
    box.setAttribute('aria-hidden', 'true');
    if (!$('.fc-drawer.is-open')) document.body.classList.remove('fc-lock');
    if (lastFocus && document.contains(lastFocus)) lastFocus.focus();
  }
  const searchBox = $('#fc-search');
  if (searchBox) {
    searchBox.addEventListener('click', (e) => { if (e.target === searchBox) closeSearch(); });
    const input = $('input[type="search"]', searchBox);
    const results = $('[data-fc-search-results]', searchBox);
    let timer;
    let controller;
    const esc = (s) => String(s || '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
    // Produkttitel normal, nur die Marke fett (wie snippets/titel-marke.liquid, dieselbe Liste der Untermarken)
    const UNTERMARKEN = ["M&M's", 'M&M', 'Snickers', 'Mars', 'Bounty', 'Twix', 'Milky Way', 'MilkyWay', 'Maltesers', 'Hubba Bubba', 'MyVitamins', 'My Supps', 'Quest', 'Warcry', 'EFX', 'BSN', 'Olimp', 'Wander Ovomaltine', 'Ovomaltine', 'Miss & Mr Fit', 'More', 'FA', 'Näno', 'Nano'];
    const titelMarke = (titel, marke) => {
      let t = String(titel || ''); let gr = '';
      const ix = t.lastIndexOf(' | '); if (ix > 0) { gr = t.slice(ix + 3).trim().replace(/(\d)(ml|kg|g|l)$/i, '$1 $2'); t = t.slice(0, ix); }
      const v = String(marke || '').replace(/&amp;/g, '&').trim();
      let n = 0;
      if (v && t.toLowerCase().startsWith(v.toLowerCase())) n = v.length;
      else for (const u of UNTERMARKEN) { if (t.toLowerCase().startsWith(u.toLowerCase()) && /^($|[ -])/.test(t.slice(u.length))) { n = u.length; break; } }
      if (n && t.charAt(n) === '.') n += 1;
      return (n ? `<b class="fc-tmarke">${esc(t.slice(0, n))}</b>${esc(t.slice(n))}` : esc(t)) + (gr ? ` <span class="fc-gr">${esc(gr)}</span>` : '');
    };
    input && input.addEventListener('input', () => {
      clearTimeout(timer);
      const q = input.value.trim();
      if (q.length < 2) { results.innerHTML = ''; return; }
      timer = setTimeout(async () => {
        if (controller) controller.abort();
        controller = new AbortController();
        try {
          const url = `${routes.predictive_search_url || '/search/suggest'}.json?q=${encodeURIComponent(q)}&resources[type]=product,collection,page&resources[limit]=6`;
          const res = await fetch(url, { signal: controller.signal });
          const data = await res.json();
          const r = (data.resources && data.resources.results) || {};
          let html = '';
          if (r.products && r.products.length) {
            html += `<h3>${esc(searchBox.dataset.labelProducts)}</h3>`;
            html += r.products.map((p) => `
              <a class="fc-search__item" href="${esc(p.url)}">
                ${p.image ? `<img src="${esc(p.image)}" alt="" width="56" height="56" loading="lazy">` : '<img alt="" width="56" height="56">'}
                <span><span class="fc-search__t">${titelMarke(p.title, p.vendor)}</span><span>${esc(p.vendor || '')}</span></span>
              </a>`).join('');
          }
          const cols = (r.collections || []).filter((c) => !/^group_/.test(c.handle || ''));
          if (cols.length) {
            html += `<h3>${esc(searchBox.dataset.labelCollections)}</h3>`;
            html += cols.map((c) => `<a class="fc-search__item" href="${esc(c.url)}"><span><b>${esc(c.title)}</b></span></a>`).join('');
          }
          if (r.pages && r.pages.length) {
            html += `<h3>${esc(searchBox.dataset.labelPages)}</h3>`;
            html += r.pages.map((c) => `<a class="fc-search__item" href="${esc(c.url)}"><span><b>${esc(c.title)}</b></span></a>`).join('');
          }
          if (!html) html = `<p class="fc-muted" style="padding:8px 6px">${esc(searchBox.dataset.labelEmpty)}</p>`;
          results.innerHTML = html;
        } catch (err) { /* abgebrochen */ }
      }, 220);
    });
  }

  /* ---------- Auswahl, die zu einer anderen Seite führt (Produktgruppe) ---------- */
  document.addEventListener('change', (e) => {
    const sel = e.target.closest('select[data-fc-nav]');
    if (sel && sel.value) window.location.href = sel.value;
  });

  /* ---------- Sprachauswahl: schliesst bei Klick daneben oder mit Escape ---------- */
  document.addEventListener('click', (e) => {
    document.querySelectorAll('details.fc-lang__dd[open]').forEach((dd) => {
      if (!dd.contains(e.target)) dd.open = false;
    });
  });
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('details.fc-lang__dd[open]').forEach((dd) => {
      dd.open = false;
      dd.querySelector('summary').focus();
    });
  });

  /* ---------- Leiste über dem Kopf: am Handy eine Zeile, Wechsel alle 5 Sekunden ---------- */
  const annBar = document.querySelector('[data-fc-ann]');
  if (annBar) {
    const items = [...annBar.querySelectorAll('.fc-ann__item')];
    const mq = window.matchMedia('(max-width: 860px)');
    let idx = 0;
    let timer = null;
    const show = (next) => {
      items.forEach((el, i) => {
        el.classList.toggle('is-on', i === next);
        el.classList.toggle('is-out', i === idx && i !== next);
      });
      idx = next;
    };
    const start = () => {
      clearInterval(timer);
      if (mq.matches && items.length > 1) {
        annBar.classList.add('is-rotating');
        items.forEach((el) => el.classList.remove('is-out'));
        idx = 0;
        items.forEach((el, i) => el.classList.toggle('is-on', i === 0));
        timer = setInterval(() => {
          if (!document.hidden) show((idx + 1) % items.length);
        }, 5000);
      } else {
        annBar.classList.remove('is-rotating');
        items.forEach((el) => el.classList.remove('is-on', 'is-out'));
      }
    };
    mq.addEventListener('change', start);
    start();
  }

  /* ---------- Kopf: bleibt oben und wird beim Scrollen kompakt ---------- */
  const topBar = document.querySelector('.fc-top');
  if (topBar) {
    const ann = topBar.querySelector('.fc-ann');
    const setAnn = () => document.documentElement.style.setProperty('--fc-ann-h', `${ann ? ann.offsetHeight : 0}px`);
    setAnn();
    window.addEventListener('resize', setAnn);
    let stuck = false;
    let ticking = false;
    const update = () => {
      ticking = false;
      const y = window.scrollY;
      // Abstand zwischen Ein- und Ausschalten, damit der Kopf an der Grenze nicht flackert
      if (!stuck && y > 140) stuck = true;
      else if (stuck && y < 60) stuck = false;
      topBar.classList.toggle('is-stuck', stuck);
    };
    window.addEventListener('scroll', () => {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }, { passive: true });
    update();
  }

  /* ---------- Fragen & Antworten: Suche und aktives Thema ---------- */
  document.querySelectorAll('[data-fc-faq]').forEach((faq) => {
    const input = faq.querySelector('[data-fc-faq-search]');
    const items = [...faq.querySelectorAll('[data-fc-faq-item]')];
    const groups = [...faq.querySelectorAll('[data-fc-faq-group]')];
    const empty = faq.querySelector('[data-fc-faq-empty]');
    const norm = (t) => t.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    if (input) {
      input.addEventListener('input', () => {
        const q = norm(input.value.trim());
        items.forEach((it) => {
          const hit = !q || norm(it.textContent).includes(q);
          it.hidden = !hit;
          if (q.length > 2) it.open = hit && norm(it.querySelector('summary').textContent).includes(q);
          else if (!q) it.open = false;
        });
        let any = false;
        groups.forEach((g) => {
          const vis = [...g.querySelectorAll('[data-fc-faq-item]')].some((it) => !it.hidden);
          g.hidden = !vis;
          if (vis) any = true;
        });
        if (empty) empty.hidden = any;
      });
    }
    const links = [...faq.querySelectorAll('.fc-faqp__nav a')];
    if (links.length && 'IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => {
        entries.forEach((en) => {
          if (!en.isIntersecting) return;
          links.forEach((a) => a.classList.toggle('is-active', a.getAttribute('href') === `#${en.target.id}`));
        });
      }, { rootMargin: '-30% 0px -60% 0px' });
      groups.forEach((g) => { if (g.id) io.observe(g); });
    }
  });

  /* ---------- Endloser Produkt-Slider ---------- */
  function initSlider(root) {
    if (root.dataset.fcReady) return;
    const track = root.querySelector('[data-fc-slider-track]');
    if (!track || track.clientWidth === 0) return; // versteckt (z. B. anderer Reiter) – später
    const slides = Array.from(track.children);
    if (!slides.length) return;
    root.dataset.fcReady = '1';
    const step = () => {
      const a = slides[0].getBoundingClientRect();
      const b = slides[1] ? slides[1].getBoundingClientRect() : a;
      return (b.left - a.left) || a.width;
    };
    const visible = () => Math.max(1, Math.round(track.clientWidth / step()));
    if (slides.length <= visible()) { root.classList.add('is-static', 'is-ready'); return; }
    const clone = (s) => {
      const c = s.cloneNode(true);
      c.setAttribute('aria-hidden', 'true');
      c.querySelectorAll('a, button, input, select').forEach((el) => { el.tabIndex = -1; });
      return c;
    };
    track.prepend(...slides.map(clone));
    track.append(...slides.map(clone));
    const start = () => slides[0].offsetLeft;
    const setWidth = () => slides[slides.length - 1].offsetLeft + step() - slides[0].offsetLeft;
    /* Sprung zwischen Original und gleich aussehender Kopie. Ohne Ausschalten des Einrastens: Safari auf dem iPhone rastet
       nach dem Wiedereinschalten sonst an einer alten Stelle ein und springt zum ersten Produkt zurück (Wilhelm 30.10.2026).
       Beide Stellen sind Einrastpunkte, darum ist der Sprung unsichtbar. */
    const jump = (x) => { track.scrollLeft = x; };
    const normalize = () => {
      const s0 = start();
      const w = setWidth();
      if (track.scrollLeft < s0 - 2) jump(track.scrollLeft + w);
      else if (track.scrollLeft >= s0 + w - 2) jump(track.scrollLeft - w);
    };
    jump(start());
    root.classList.add('is-ready');
    // Fortschrittsbalken unter dem Slider: Breite = sichtbarer Anteil, Lage = Position im (endlosen) Durchlauf
    const bar = root.querySelector('[data-fc-slider-bar]');
    const updBar = () => {
      if (!bar) return;
      const w = setWidth(); const vis = Math.min(1, track.clientWidth / w);
      const off = (((track.scrollLeft - start()) % w) + w) % w;
      const pos = Math.min(1, off / Math.max(1, w - track.clientWidth));
      bar.style.width = (vis * 100) + '%'; bar.style.left = (pos * (1 - vis) * 100) + '%';
    };
    updBar();
    // Erst springen, wenn der Finger weg ist und das Wischen ganz ausgelaufen ist
    let timer; let finger = false;
    const spaeter = (ms) => { clearTimeout(timer); if (!finger) timer = setTimeout(normalize, ms); };
    track.addEventListener('scroll', () => { updBar(); spaeter(180); }, { passive: true });
    track.addEventListener('touchstart', () => { finger = true; clearTimeout(timer); }, { passive: true });
    const los = () => { finger = false; spaeter(260); };
    track.addEventListener('touchend', los, { passive: true });
    track.addEventListener('touchcancel', los, { passive: true });
    if ('onscrollend' in window) track.addEventListener('scrollend', () => { if (!finger) { clearTimeout(timer); normalize(); } });
    const move = (dir) => {
      normalize();
      track.scrollBy({ left: dir * step() * Math.max(1, visible() - 1), behavior: 'smooth' });
    };
    root.querySelector('[data-fc-slider-prev]')?.addEventListener('click', () => move(-1));
    root.querySelector('[data-fc-slider-next]')?.addEventListener('click', () => move(1));
    let rt;
    window.addEventListener('resize', () => { clearTimeout(rt); rt = setTimeout(normalize, 200); });
  }
  window.fcInitSliders = (scope = document) => $$('[data-fc-slider]', scope).forEach(initSlider);
  window.fcInitSliders();

  /* ---------- Kartenfarbe: zarter Hintergrund aus der Farbe des Produktbilds ---------- */
  (() => {
    if (!('IntersectionObserver' in window) || !window.createImageBitmap) return;
    const KEY = 'fc-kartenfarbe-3';
    let cache = {};
    try { cache = JSON.parse(localStorage.getItem(KEY) || '{}'); } catch (e) { cache = {}; }
    let saveT;
    const save = () => { clearTimeout(saveT); saveT = setTimeout(() => { try { localStorage.setItem(KEY, JSON.stringify(cache)); } catch (e) {} }, 400); };
    const mix = (c, a) => 'rgb(' + c.map((v) => Math.round(v * a + 255 * (1 - a))).join(',') + ')';
    const apply = (media, v) => {
      if (!v) return;
      // Foto mit eigenem Hintergrund (nicht freigestellt, z. B. Mode): keine Farbfläche, das Bild füllt die Fläche (Wilhelm 30.10.2026)
      if (v.f) { media.classList.add('kt-foto'); return; }
      // Foto mit eigenem weissem Hintergrund: ohne Farbfläche normal auf Weiss, auf der Produktseite und auf Karten
      // (Wilhelm 31.10.2026: «ja auf karten, auch auf weiss»). Freigestellte Bilder behalten die Kartenfarbe.
      if (v.w) { media.classList.add('kt-weissbild'); return; }
      const c = v.c; if (!c) return;
      media.style.setProperty('--kt', mix(c, 0.16));
      media.style.setProperty('--kt2', mix(c, 0.30));
      media.classList.add('has-kt');
    };
    const measure = async (src) => {
      const u = new URL(src, location.href); u.searchParams.set('width', '80');
      const bmp = await createImageBitmap(await (await fetch(u.toString())).blob());
      const cv = document.createElement('canvas'); cv.width = 40; cv.height = 40;
      const x = cv.getContext('2d', { willReadFrequently: true }); x.drawImage(bmp, 0, 0, 40, 40);
      const d = x.getImageData(0, 0, 40, 40).data; let r = 0, g = 0, b = 0, n = 0;
      const px = (i) => [d[i], d[i + 1], d[i + 2], d[i + 3]];
      const weiss = [0, 39 * 4, 39 * 40 * 4, (40 * 40 - 1) * 4].every((i) => { const q = px(i); return q[3] > 250 && Math.min(q[0], q[1], q[2]) > 232; });
      for (let i = 0; i < d.length; i += 4) {
        if (d[i + 3] < 200) continue;
        const R = d[i], G = d[i + 1], B = d[i + 2], mx = Math.max(R, G, B), mn = Math.min(R, G, B);
        if (mx - mn < 40 || mx < 60) continue;
        r += R; g += G; b += B; n++;
      }
      // Alle vier Ecken deckend und nicht weiss: Foto mit eigenem Hintergrund (Studio, Raum)
      const foto = !weiss && [0, 39 * 4, 39 * 40 * 4, (40 * 40 - 1) * 4].every((i) => px(i)[3] > 250);
      return { c: n < 12 ? null : [r / n, g / n, b / n], w: weiss, f: foto };
    };
    // Flächen mit Farbton: Bildfläche der Produktkarten, Galeriebilder und Vorschaubilder der Produktseite, Markenkarten der Startseite, «Passt zusammen»
    const SEL = '.fc-card__media, .fc-stage__slide, .fc-thumb, .fc-bcard__media, .fc-bitem__img';
    const done = new Set();
    const pending = {};
    const KT = ['kt-foto', 'kt-weiss', 'kt-weissbild', 'has-kt'];
    window.fcNeuFaerben = (media) => {
      KT.forEach((c) => media.classList.remove(c));
      media.style.removeProperty('--kt'); media.style.removeProperty('--kt2');
      done.delete(media); tint(media);
    };
    const tint = async (media) => {
      if (done.has(media)) return; done.add(media);
      const img = media.querySelector('img');
      if (!img || img.classList.contains('is-cover')) return;
      const src = img.currentSrc || img.getAttribute('src') || ''; if (!src) return;
      const k = src.split('?')[0].split('/').pop();
      if (k in cache) { apply(media, cache[k]); return; }
      try {
        if (!pending[k]) pending[k] = measure(src).then((v) => { cache[k] = v; save(); return v; });
        apply(media, await pending[k]);
      } catch (e) {}
    };
    // Sobald eine Fläche in die Nähe kommt: alle Flächen derselben Reihe einfärben (auch nicht sichtbare in Slidern und Galerie)
    const ROW = '[data-fc-slider-track], .fc-grid4, .fc-grid3, .fc-stage__track, .fc-thumbs, .fc-bcards, .fc-bundle';
    const io = new IntersectionObserver((es) => es.forEach((e) => {
      if (!e.isIntersecting) return;
      const row = e.target.closest(ROW) || e.target.parentElement;
      $$(SEL, row).forEach((m) => { io.unobserve(m); tint(m); });
    }), { rootMargin: '400px' });
    const scan = (root) => $$(SEL, root).forEach((m) => { if (!done.has(m)) io.observe(m); });
    scan(document);
    new MutationObserver((ms) => ms.forEach((m) => m.addedNodes.forEach((nd) => { if (nd.nodeType === 1) { if (nd.matches && nd.matches(SEL)) io.observe(nd); else scan(nd); } }))).observe(document.body, { childList: true, subtree: true });
  })();

  /* ---------- Farbpunkte auf Produktkarten (Wilhelm 31.10.2026): Darüberfahren zeigt die Farbe, Antippen wählt sie
     (Bild bleibt, Links der Karte öffnen diese Farbe). Über das Dokument, damit es auch in kopierten Slider-Karten geht. ---------- */
  const swBild = (card, sw) => {
    const media = card.querySelector('.fc-card__media');
    const img = media && media.querySelector('img');
    if (!img || !sw.dataset.src) return;
    if (img.getAttribute('src') === sw.dataset.src) return;
    img.setAttribute('srcset', sw.dataset.srcset || '');
    img.setAttribute('src', sw.dataset.src);
    img.loading = 'eager';
    if (window.fcNeuFaerben) window.fcNeuFaerben(media);
  };
  const swGewaehlt = (box) => box.querySelector('[data-fc-sw][aria-pressed="true"]') || box.querySelector('[data-fc-sw]');
  document.addEventListener('pointerover', (e) => {
    if (e.pointerType !== 'mouse') return;
    const sw = e.target.closest && e.target.closest('[data-fc-sw]');
    if (!sw) return;
    const card = sw.closest('.fc-card'); if (card) swBild(card, sw);
  });
  document.addEventListener('pointerout', (e) => {
    if (e.pointerType !== 'mouse') return;
    const box = e.target.closest && e.target.closest('[data-fc-swatches]');
    if (!box || (e.relatedTarget && box.contains(e.relatedTarget))) return;
    const card = box.closest('.fc-card'); const sel = swGewaehlt(box);
    if (card && sel) swBild(card, sel);
  });
  document.addEventListener('click', (e) => {
    const sw = e.target.closest && e.target.closest('[data-fc-sw]');
    if (!sw) return;
    e.preventDefault(); e.stopPropagation();
    const box = sw.closest('[data-fc-swatches]'); const card = sw.closest('.fc-card');
    $$('[data-fc-sw]', box).forEach((b) => b.setAttribute('aria-pressed', b === sw ? 'true' : 'false'));
    if (card) {
      swBild(card, sw);
      $$('a.fc-card__link, .fc-card__title a, a.fc-add', card).forEach((a) => { a.href = sw.dataset.url; });
    }
  }, true);

  /* ---------- Warenkorb ---------- */
  const DRAWER_SECTION = 'cart-drawer';

  function setCount(count) {
    $$('[data-fc-cart-count]').forEach((el) => {
      el.textContent = count;
      el.hidden = !count;
    });
  }

  const recoCache = {};

  function loadDrawerReco() {
    const box = $('[data-fc-drawer-reco]');
    if (!box || box.dataset.loaded) return;
    const url = box.getAttribute('data-url');
    const exclude = (box.getAttribute('data-exclude') || '').split(',').filter(Boolean);
    const fill = (html) => {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const inner = doc.querySelector('[data-fc-reco-inner]');
      if (!inner) return;
      $$('.fc-mini', inner).forEach((card) => { if (exclude.includes(card.dataset.productId)) card.remove(); });
      if ($$('.fc-mini', inner).length) { box.innerHTML = ''; box.appendChild(inner); }
      box.dataset.loaded = '1';
    };
    if (recoCache[url]) return fill(recoCache[url]);
    fetch(url).then((r) => r.text()).then((html) => { recoCache[url] = html; fill(html); }).catch(() => {});
  }

  function renderDrawer(sections) {
    if (!sections || !sections[DRAWER_SECTION]) return;
    const doc = new DOMParser().parseFromString(sections[DRAWER_SECTION], 'text/html');
    // Anzahl zuerst auslesen: nach dem Einsetzen gehört der Inhalt nicht mehr zu «doc»
    const countEl = doc.querySelector('[data-fc-drawer-count]');
    const newCount = countEl ? (parseInt(countEl.getAttribute('data-fc-drawer-count'), 10) || 0) : null;
    const fresh = doc.querySelector('[data-fc-drawer-inner]');
    const current = $('[data-fc-drawer-inner]');
    const oldBar = current && current.querySelector('[data-fc-bar]');
    const oldPct = oldBar ? parseFloat(oldBar.getAttribute('data-fc-pct')) : 0;
    if (fresh && current) {
      // Bereits angezeigte Zeilen nicht nochmals einblenden
      const shownKeys = new Set($$('[data-fc-line-key]', current).map((b) => b.getAttribute('data-fc-line-key')));
      $$('.fc-ci', fresh).forEach((li) => {
        const btn = li.querySelector('[data-fc-line-key]');
        if (btn && shownKeys.has(btn.getAttribute('data-fc-line-key'))) li.style.animation = 'none';
      });
      // Versand-Leiste gleichmässig vom alten zum neuen Stand wachsen lassen
      const bar = fresh.querySelector('[data-fc-bar]');
      let target = null;
      if (bar) {
        target = bar.getAttribute('data-fc-pct');
        bar.dataset.shown = '1';
        bar.style.width = (oldBar ? oldPct : 0) + '%';
      }
      current.replaceWith(fresh);
      if (bar) {
        requestAnimationFrame(() => requestAnimationFrame(() => { bar.style.width = target + '%'; }));
        // Gratisversand gerade erreicht: kurz feiern (Emoji und Konfetti, Wilhelm 30.10.2026)
        const ship = fresh.querySelector('.fc-cartd__ship');
        if (ship && (oldBar ? oldPct : 0) < 100 && parseFloat(target) >= 100) {
          setTimeout(() => { ship.classList.add('is-feier'); setTimeout(() => ship.classList.remove('is-feier'), 1800); }, 450);
        }
      }
    }
    if (newCount !== null) setCount(newCount);
    loadDrawerReco();
  }

  /* Warenkorb aus dem Shop neu laden (Wilhelm 30.10.2026: Produkte erschienen erst nach Neuladen). Grund: Beim Zurückblättern zeigt
     der Browser die Seite aus seinem Zwischenspeicher mit altem Warenkorb. Darum nach dem Zurückblättern, beim Zurückkehren in den Tab
     und beim Öffnen des Warenkorbs den aktuellen Stand holen, nur wenn er sich geändert hat. */
  let refreshing = null;
  /* Zählt jede Änderung am Warenkorb. Eine Antwort, die älter ist als die letzte Änderung, wird nicht mehr angezeigt
     (sonst konnte ein eben entferntes Produkt wieder erscheinen). */
  let drawerVersion = 0;
  async function refreshDrawer(force) {
    if (refreshing && !force) return refreshing;
    const v = drawerVersion;
    refreshing = (async () => {
      try {
        const root = (routes.root_url || '/').replace(/\/$/, '');
        const cart = await (await fetch(`${root}/cart.js`, { cache: 'no-store' })).json();
        const stand = cart.item_count + ':' + cart.total_price + ':' + cart.items.map((i) => i.key + 'x' + i.quantity + ',').join('');
        const shown = document.querySelector('[data-fc-drawer-stand]');
        if (!force && shown && shown.getAttribute('data-fc-drawer-stand') === stand) return;
        const res = await fetch(`${root}/?sections=${DRAWER_SECTION}`, { cache: 'no-store' });
        const data = await res.json();
        if (v !== drawerVersion) return;
        renderDrawer(data);
      } catch (e) { /* ohne Netz bleibt der bisherige Stand */ }
      finally { refreshing = null; }
    })();
    return refreshing;
  }
  window.addEventListener('pageshow', (e) => { if (e.persisted) refreshDrawer(); });
  document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'visible') refreshDrawer(); });

  /* Der Side Cart öffnet erst, wenn der Shop das Produkt bestätigt hat (Wilhelm 30.10.2026: sofortiges Öffnen mit Vorschau
     war nicht zuverlässig, «lieber später öffnen, aber dafür funktioniert alles») */
  async function addItems(items, button) {
    drawerVersion += 1;
    if (button) button.classList.add('is-loading');
    try {
      const res = await fetch(`${routes.cart_add_url || '/cart/add'}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items, sections: DRAWER_SECTION })
      });
      const data = await res.json();
      if (!res.ok || data.status) {
        toast(data.description || data.message || strings.error || 'Fehler');
        return false;
      }
      drawerVersion += 1;
      renderDrawer(data.sections);
      if (document.body.classList.contains('fc-template-cart')) {
        window.location.reload();
      } else {
        openDrawer('fc-cart-drawer', true);
      }
      return true;
    } catch (err) {
      toast(strings.error || 'Fehler');
      return false;
    } finally {
      if (button) button.classList.remove('is-loading');
    }
  }

  /* Preise sofort anpassen (Zeile, Summe im Button, Versandbalken), ohne auf den Shop zu warten.
     Die Antwort des Shops ersetzt danach alles mit den genauen Werten (z. B. bei Rabatten). */
  function sofortPreise(li, qty) {
    if (!li) return;
    const inner = li.closest('[data-fc-drawer-inner]');
    const fmt = inner && inner.dataset.moneyFormat;
    const unit = parseInt(li.dataset.fcUnit, 10);
    const alt = parseInt(li.dataset.fcQty, 10);
    if (!inner || Number.isNaN(unit) || Number.isNaN(alt)) return;
    li.dataset.fcQty = qty;
    const lp = li.querySelector('[data-fc-lp]');
    if (lp && qty > 0) lp.textContent = formatMoney(unit * qty, fmt);
    const sumEl = inner.querySelector('[data-fc-sum]');
    if (!sumEl) return;
    const summe = Math.max(0, (parseInt(sumEl.dataset.fcSum, 10) || 0) + (qty - alt) * unit);
    sumEl.dataset.fcSum = summe;
    const txt = sumEl.querySelector('[data-fc-sum-txt]');
    if (txt) txt.textContent = formatMoney(summe, fmt);
    const bar = inner.querySelector('[data-fc-bar]');
    const schwelle = parseInt((inner.querySelector('[data-fc-schwelle]') || {}).dataset?.fcSchwelle, 10);
    if (bar && schwelle > 0) {
      const pct = Math.min(100, (summe * 100) / schwelle);
      bar.style.width = pct + '%';
      const b = inner.querySelector('.fc-cartd__ship p b');
      if (b && summe < schwelle) b.textContent = formatMoney(schwelle - summe, fmt);
    }
  }

  /* Änderungen gehen nacheinander an den Shop; angezeigt wird nur die Antwort auf die letzte Änderung.
     Klappt etwas nicht, wird der echte Stand aus dem Shop geholt. */
  let lineQueue = Promise.resolve();
  function changeLine(key, quantity) {
    drawerVersion += 1;
    const v = drawerVersion;
    const drawer = $('#fc-cart-drawer');
    if (drawer) drawer.classList.add('is-busy');
    lineQueue = lineQueue.then(async () => {
      let ok = false;
      try {
        const res = await fetch(`${routes.cart_change_url || '/cart/change'}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: key, quantity, sections: DRAWER_SECTION })
        });
        const data = await res.json();
        if (!res.ok || data.status) toast(data.description || data.message || strings.error || 'Fehler');
        else if (data.sections && data.sections[DRAWER_SECTION]) { ok = true; if (v === drawerVersion) renderDrawer(data.sections); }
      } catch (err) {
        toast(strings.error || 'Fehler');
      }
      if (!ok && v === drawerVersion) await refreshDrawer(true);
      if (v === drawerVersion && drawer) drawer.classList.remove('is-busy');
    });
    return lineQueue;
  }

  // Produktformular
  document.addEventListener('submit', (e) => {
    const form = e.target.closest('form[data-fc-product-form]');
    if (!form) return;
    e.preventDefault();
    const fd = new FormData(form);
    const id = fd.get('id');
    const quantity = parseInt(fd.get('quantity') || '1', 10) || 1;
    if (!id) return;
    const item = { id: Number(id), quantity };
    const props = {};
    for (const [k, v] of fd.entries()) {
      const m = k.match(/^properties\[(.+)\]$/);
      if (m && v) props[m[1]] = v;
    }
    if (Object.keys(props).length) item.properties = props;
    addItems([item], form.querySelector('[type="submit"]'));
  });

  // Schnell hinzufügen & Paket
  document.addEventListener('click', (e) => {
    const quick = e.target.closest('[data-fc-quick-add]');
    if (quick) {
      e.preventDefault();
      addItems([{ id: Number(quick.getAttribute('data-fc-quick-add')), quantity: 1 }], quick);
      return;
    }
    const bundle = e.target.closest('[data-fc-bundle-add]');
    if (bundle) {
      e.preventDefault();
      const teile = (bundle.getAttribute('data-fc-bundle-add') || '').split(',').filter(Boolean);
      addItems(teile.map((t) => { const [id, q] = t.split(':'); return { id: Number(id), quantity: Math.max(1, Number(q) || 1) }; }), bundle);
      return;
    }
    const lineBtn = e.target.closest('[data-fc-line-qty]');
    if (lineBtn && lineBtn.closest('[data-fc-drawer-inner]')) {
      e.preventDefault();
      const key = lineBtn.getAttribute('data-fc-line-key');
      const qty = Math.max(0, parseInt(lineBtn.getAttribute('data-fc-line-qty'), 10) || 0);
      const li = lineBtn.closest('.fc-ci');
      sofortPreise(li, qty);
      if (li && qty === 0) {
        li.classList.add('is-weg');
        setTimeout(() => { li.hidden = true; }, 220);
      } else if (li) {
        const btns = li.querySelectorAll('.fc-ci__qty [data-fc-line-qty]');
        const zahl = li.querySelector('.fc-ci__qty span');
        if (zahl) zahl.textContent = qty;
        if (btns.length === 2) { btns[0].setAttribute('data-fc-line-qty', qty - 1); btns[1].setAttribute('data-fc-line-qty', qty + 1); }
      }
      changeLine(key, qty);
    }
  });

  /* «Passt zusammen»: Sorte und Menge je Produkt → Bild, Preis, Kassenzettel, Summe, Ersparnis, Anzahl und Warenkorb-Inhalt */
  const bundleRechnen = (box) => {
    const fmt = box.dataset.moneyFormat;
    let tot = 0; let spar = 0; let anzahl = 0; const teile = [];
    box.querySelectorAll('[data-fc-bitem]:not([data-off])').forEach((it) => {
      const pr = Number(it.dataset.price) || 0; const co = Number(it.dataset.compare) || 0;
      const q = Math.max(1, Number(it.dataset.qty) || 1);
      tot += pr * q; if (co > pr) spar += (co - pr) * q; anzahl += q;
      teile.push(it.dataset.variant + ':' + q);
      const li = box.querySelector(`[data-fc-bline="${it.dataset.fcBitem}"]`);
      if (li) {
        li.querySelector('span').textContent = (q > 1 ? q + '× ' : '') + li.dataset.base + (li.dataset.label ? ' · ' + li.dataset.label : '');
        li.querySelector('b').textContent = formatMoney(pr * q, '{{amount}}');
      }
    });
    const totEl = box.querySelector('[data-fc-bsum-tot]');
    if (totEl) totEl.textContent = formatMoney(tot, fmt);
    const sv = box.querySelector('[data-fc-bsum-save]');
    if (sv) { sv.textContent = (box.dataset.saveTpl || '').replace('[amount]', formatMoney(spar, fmt)); sv.hidden = spar <= 0; }
    const cnt = box.querySelector('[data-fc-bsum-count]');
    if (cnt) cnt.textContent = anzahl === 1 ? cnt.dataset.one : (cnt.dataset.other || '').replace('99', anzahl);
    const btn = box.querySelector('[data-fc-bundle-add]');
    if (btn) btn.setAttribute('data-fc-bundle-add', teile.join(',') + ',');
  };
  document.addEventListener('change', (e) => {
    const sel = e.target.closest('[data-fc-bitem-select]');
    if (!sel) return;
    const item = sel.closest('[data-fc-bitem]');
    const box = sel.closest('[data-fc-bundle]');
    const opt = sel.selectedOptions[0];
    if (!item || !box || !opt) return;
    const fmt = box.dataset.moneyFormat;
    const price = Number(opt.dataset.price) || 0;
    const compare = Number(opt.dataset.compare) || 0;
    item.dataset.variant = sel.value;
    item.dataset.price = price;
    item.dataset.compare = compare;
    const img = item.querySelector('.fc-bitem__img img');
    const src = opt.dataset.img || sel.dataset.defaultImg;
    if (img && src) { img.removeAttribute('srcset'); img.src = src; }
    const onSale = compare > price;
    const preis = item.querySelector('.fc-bitem__price');
    if (preis) preis.innerHTML = `<span class="fc-price${onSale ? ' fc-price--sale' : ''}">${formatMoney(price, fmt)}${onSale ? ` <s><span class="fc-visually-hidden">${box.dataset.regular || ''}</span>${formatMoney(compare, fmt)}</s>` : ''}</span>`;
    const li = box.querySelector(`[data-fc-bline="${item.dataset.fcBitem}"]`);
    if (li) li.dataset.label = opt.dataset.label || opt.textContent.trim();
    bundleRechnen(box);
  });
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-fc-bitem-qty] [data-minus], [data-fc-bitem-qty] [data-plus]');
    if (!b) return;
    const item = b.closest('[data-fc-bitem]');
    const box = b.closest('[data-fc-bundle]');
    if (!item || !box) return;
    const MAX = 10;
    let q = Math.max(1, Number(item.dataset.qty) || 1) + (b.hasAttribute('data-plus') ? 1 : -1);
    q = Math.min(MAX, Math.max(1, q));
    item.dataset.qty = q;
    const wrap = b.closest('[data-fc-bitem-qty]');
    wrap.querySelector('output').textContent = q;
    wrap.querySelector('[data-minus]').disabled = q <= 1;
    wrap.querySelector('[data-plus]').disabled = q >= MAX;
    bundleRechnen(box);
  });

  /* ---------- Mengenwahl ---------- */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-fc-step]');
    if (!btn) return;
    const wrap = btn.closest('.fc-qty');
    const input = wrap && $('input', wrap);
    if (!input) return;
    const step = parseInt(btn.getAttribute('data-fc-step'), 10) || 0;
    const min = parseInt(input.min || '1', 10);
    const next = Math.max(min, (parseInt(input.value, 10) || min) + step);
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Reiter (Startseite) ---------- */
  $$('[data-fc-tabs]').forEach((root) => {
    const tabs = $$('[role="tab"]', root);
    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        tabs.forEach((t) => {
          const on = t === tab;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
          const panel = document.getElementById(t.getAttribute('aria-controls'));
          if (panel) {
            panel.hidden = !on;
            if (on && window.fcInitSliders) window.fcInitSliders(panel);
          }
        });
      });
      tab.addEventListener('keydown', (e) => {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        const i = tabs.indexOf(tab);
        const next = tabs[(i + (e.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length];
        next.focus();
        next.click();
      });
    });
  });

  /* ---------- FAQ: Liste + Antwortfeld ---------- */
  $$('[data-fc-faq]').forEach((root) => {
    const qs = $$('[data-fc-q]', root);
    qs.forEach((q) => {
      q.addEventListener('click', () => {
        qs.forEach((x) => {
          const on = x === q;
          x.setAttribute('aria-selected', on ? 'true' : 'false');
          const panel = document.getElementById(x.getAttribute('aria-controls'));
          if (panel) panel.hidden = !on;
        });
      });
    });
  });

  /* ---------- Bildergalerie: Bilder gleiten seitlich (Wischen, Pfeile, kleine Bilder), die Leiste der kleinen Bilder fährt mit.
     Je Sorte nur Sortenbild, Zusatzbilder der Sorte und allgemeine Bilder (Wilhelm 31.10.2026); beim Sortenwechsel wird umgestellt. ---------- */
  function initGallery(root, data) {
    const track = $('[data-fc-track]', root);
    const bar = $('.fc-thumbs', root);
    if (!track || !$('[data-fc-slide]', track)) return null;
    const folieVon = new Map($$('[data-fc-slide]', track).map((s) => [s.getAttribute('data-fc-media-id'), s]));
    const bildchenVon = new Map($$('[data-fc-thumb]', root).map((t) => [t.getAttribute('data-fc-media-id'), t]));
    const navs = $$('[data-fc-prev], [data-fc-next]', root);
    let slides = $$('[data-fc-slide]:not([hidden])', track);
    let thumbs = $$('[data-fc-thumb]:not([hidden])', root);
    let index = Math.max(0, slides.findIndex((s) => s.classList.contains('is-active')));
    let ziel = null;
    let ruhe;
    const breite = () => Math.max(1, track.clientWidth);
    function folgen(i, sanft) {
      const t = thumbs[i];
      if (!t || !bar) return;
      const r = t.getBoundingClientRect();
      const b = bar.getBoundingClientRect();
      const dx = (r.left + r.width / 2) - (b.left + b.width / 2);
      if (Math.abs(dx) > 1) bar.scrollBy({ left: dx, behavior: sanft ? 'smooth' : 'auto' });
    }
    function markieren(i, sanft = true) {
      index = i;
      slides.forEach((s, n) => {
        const on = n === i;
        s.classList.toggle('is-active', on);
        s.setAttribute('aria-hidden', on ? 'false' : 'true');
        const vid = s.querySelector('video');
        if (vid && !on) vid.pause();
      });
      thumbs.forEach((t, n) => t.setAttribute('aria-current', n === i ? 'true' : 'false'));
      folgen(i, sanft);
    }
    function show(i, sanft = true) {
      if (!slides.length) return;
      const n = (i + slides.length) % slides.length;
      ziel = n;
      // weite Sprünge: direkt neben das Ziel springen und nur das letzte Bild gleiten lassen
      if (sanft && Math.abs(n - index) > 1) track.scrollLeft = (n + (n > index ? -1 : 1)) * breite();
      track.scrollTo({ left: n * breite(), behavior: sanft ? 'smooth' : 'auto' });
      markieren(n, sanft);
      if (!sanft) ziel = null;
    }
    track.addEventListener('scroll', () => {
      clearTimeout(ruhe);
      ruhe = setTimeout(() => {
        ziel = null;
        const n = Math.round(track.scrollLeft / breite());
        if (n !== index && n >= 0 && n < slides.length) markieren(n);
      }, 90);
      if (ziel !== null) return;
      const n = Math.round(track.scrollLeft / breite());
      if (n !== index && n >= 0 && n < slides.length) markieren(n);
    }, { passive: true });
    bildchenVon.forEach((t) => t.addEventListener('click', () => { const n = thumbs.indexOf(t); if (n > -1) show(n); }));
    const prev = $('[data-fc-prev]', root);
    const next = $('[data-fc-next]', root);
    prev && prev.addEventListener('click', () => show(index - 1));
    next && next.addEventListener('click', () => show(index + 1));
    window.addEventListener('resize', () => { track.scrollLeft = index * breite(); });
    root.addEventListener('fc:gallery-show', (e) => {
      const n = slides.findIndex((s) => s.getAttribute('data-fc-media-id') === String(e.detail));
      if (n > -1) show(n, false);
    });

    /* Bilder einer Sorte: Sortenbild, Zusatzbilder (custom.galerie), dann alle Bilder, die keiner Sorte gehören */
    const alleMedien = (data && data.medien) || [];
    const sortenBilder = new Set();
    ((data && data.variants) || []).forEach((v) => {
      if (v.featured_media_id) sortenBilder.add(String(v.featured_media_id));
      (v.galerie || []).forEach((g) => sortenBilder.add(String(g)));
    });
    function bilderDer(v) {
      const liste = [];
      const dazu = (m) => { m = String(m); if (m && folieVon.has(m) && !liste.includes(m)) liste.push(m); };
      if (v && v.featured_media_id) dazu(v.featured_media_id);
      ((v && v.galerie) || []).forEach(dazu);
      alleMedien.forEach((m) => { if (!sortenBilder.has(String(m))) dazu(m); });
      return liste;
    }
    let aktuelleSorte = null;
    function zeigeSorte(v) {
      if (!v || !alleMedien.length) return;
      if (aktuelleSorte === v.id) return;
      aktuelleSorte = v.id;
      const ids = bilderDer(v);
      if (!ids.length) return;
      const zeigen = new Set(ids);
      // Reihenfolge im Dokument: sichtbare Bilder der Sorte zuerst, alle übrigen versteckt dahinter
      ids.forEach((m) => track.appendChild(folieVon.get(m)));
      folieVon.forEach((s, m) => { s.hidden = !zeigen.has(m); if (!zeigen.has(m)) track.appendChild(s); });
      if (bar) {
        ids.forEach((m) => { const t = bildchenVon.get(m); if (t) bar.appendChild(t); });
        bildchenVon.forEach((t, m) => { t.hidden = !zeigen.has(m); if (!zeigen.has(m)) bar.appendChild(t); });
        bar.hidden = ids.length < 2;
      }
      navs.forEach((b) => { b.hidden = ids.length < 2; });
      slides = ids.map((m) => folieVon.get(m));
      thumbs = bar ? ids.map((m) => bildchenVon.get(m)).filter(Boolean) : [];
      const erstesBild = slides[0] && $('img', slides[0]);
      if (erstesBild) erstesBild.loading = 'eager';
      index = 0;
      show(0, false);
    }
    const start = data && data.variants && data.variants.find((v) => v.id === data.selected_variant_id);
    if (start) aktuelleSorte = start.id;
    show(index, false);
    return {
      zeigeSorte,
      showMedia(mediaId) {
        const n = slides.findIndex((s) => s.getAttribute('data-fc-media-id') === String(mediaId));
        if (n > -1) show(n);
      }
    };
  }

  /* ---------- Pflichtangaben je Sorte: weicht eine Sorte ab, zeigt der Abschnitt Was drin steckt ihren Block ---------- */
  document.addEventListener('fc:variant', (e) => {
    const id = String(e.detail && e.detail.id);
    $$('[data-fc-sorte-gruppe]').forEach((g) => {
      const bloecke = Array.from(g.children).filter((b) => b.hasAttribute('data-fc-sorte'));
      const eigener = bloecke.some((b) => b.getAttribute('data-fc-sorte') === id);
      bloecke.forEach((b) => { b.hidden = b.getAttribute('data-fc-sorte') !== (eigener ? id : 'default'); });
    });
  });

  /* ---------- Nährwerte: der Mengenregler rechnet die Kennzahlen je Portion hoch, nur mit den deklarierten Werten ---------- */
  function nwZahl(x) {
    if (x === null || x === undefined || isNaN(x)) return '–';
    const a = Math.abs(x);
    return String(a >= 100 ? Math.round(x) : a >= 1 ? Math.round(x * 10) / 10 : Math.round(x * 100) / 100);
  }
  $$('[data-fc-nw]').forEach((el) => {
    const minus = $('[data-fc-nw-minus]', el);
    const plus = $('[data-fc-nw-plus]', el);
    const titel = $$('[data-fc-nw-ptitel]', el);
    if (!minus || !plus || !titel.length) return;
    const pmenge = $('[data-fc-nw-pmenge]', el);
    const mtext = $('[data-fc-nw-mtext]', el);
    const portion = el.dataset.portion || '';
    const treffer = portion.match(/\(([\d.,]+)\s*(g|ml)\)/i) || portion.match(/([\d.,]+)\s*(g|ml)\b/i);
    const menge = treffer ? parseFloat(treffer[1].replace(',', '.')) : null;
    const einheit = treffer ? treffer[2].toLowerCase() : '';
    const zahl = (x) => parseFloat(String(x || '').replace(',', '.'));
    const wert = (x, lt, n, unit, ganz) => (isNaN(zahl(x)) ? '–' : `${lt ? '&lt;\u00a0' : ''}${ganz ? Math.round(zahl(x) * n) : nwZahl(zahl(x) * n)}\u00a0${unit}`);
    let n = 1;
    // Energie steht oben im Feld pro Portion (Wert in .fc-nt__ewert), die übrigen Nährstoffe in der Tabellenspalte
    const zellen = $$('.fc-nt__p', el);
    const ziel = (z) => $('.fc-nt__ewert', z) || z;
    const original = zellen.map((z) => ziel(z).innerHTML);
    const zeig = () => {
      zellen.forEach((z, i) => {
        const t = ziel(z);
        if (n === 1) {
          t.innerHTML = original[i];
        } else if (z.dataset.kcal !== undefined) {
          t.innerHTML = `<b class="fc-nt__kcal">${wert(z.dataset.kcal, z.dataset.ltKcal, n, 'kcal', true)}</b><span class="fc-nt__kj">${wert(z.dataset.kj, z.dataset.ltKj, n, 'kJ', true)}</span>`;
        } else {
          t.innerHTML = wert(z.dataset.wert, z.dataset.lt, n, 'g');
        }
      });
      titel.forEach((t) => { t.textContent = n === 1 ? (el.dataset.textOne || '') : (el.dataset.textOther || '').replace('[n]', n); });
      const gesamt = n === 1 ? portion : (menge ? `${nwZahl(menge * n)} ${einheit}` : `${n} × ${portion}`);
      if (pmenge) pmenge.textContent = gesamt;
      if (mtext) mtext.textContent = ((n === 1 ? el.dataset.mengeOne : el.dataset.mengeOther) || '').replace('[n]', n) + (gesamt ? ` · ${gesamt}` : '');
      minus.disabled = n <= 1;
      plus.disabled = n >= 10;
    };
    minus.addEventListener('click', () => { if (n > 1) { n -= 1; zeig(); } });
    plus.addEventListener('click', () => { if (n < 10) { n += 1; zeig(); } });
  });

  /* ---------- Produkt: Varianten, Preis, MHD ---------- */
  function formatMoney(cents, format) {
    const fmt = format || 'CHF {{amount}}';
    const value = (cents / 100);
    const withDelims = (n, dec, thou, sep) => {
      const parts = n.toFixed(dec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
      return parts.join(sep);
    };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (m, key) => {
      switch (key) {
        case 'amount_no_decimals': return withDelims(value, 0, "'", '.');
        case 'amount_with_comma_separator': return withDelims(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelims(value, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return withDelims(value, 2, "'", '.');
        default: return withDelims(value, 2, "'", '.');
      }
    });
  }

  function parseMhd(str) {
    const parts = String(str || '').trim().split('.');
    if (parts.length !== 3) return null;
    const d = new Date(parseInt(parts[2], 10), parseInt(parts[1], 10) - 1, parseInt(parts[0], 10));
    return isNaN(d.getTime()) ? null : d;
  }

  // MHD-Hinweis: Die Preisautomatik (core.iq) entscheidet je Variante über das Feld «MHD-Hinweis anzeigen»
  // (ab Konsumdauer vor dem MHD, spätestens 30 Tage, nach dem MHD und bei MHD-Sale; nicht bei Ladenhüter-Rabatt).
  // Ohne Wert gilt die bisherige Regel aus dem alten Shop: bei Aktion oder kurzer Restlaufzeit.
  function shouldShowMhd(variant) {
    const date = parseMhd(variant.mhd);
    if (!date) return false;
    if (typeof variant.mhd_hinweis === 'boolean') return variant.mhd_hinweis;
    const days = Math.floor((date - new Date()) / (1000 * 3600 * 24));
    const price = variant.price / 100;
    const compare = (variant.compare_at_price || 0) / 100;
    const effective = compare || price;
    return compare > 0.01 ||
      (effective < 5 && days < 21) ||
      (effective >= 5 && effective <= 80 && days < 35) ||
      (effective > 80 && days < 61);
  }

  $$('[data-fc-product]').forEach((root) => {
    const dataEl = $('script[data-fc-product-json]', root);
    if (!dataEl) return;
    const data = JSON.parse(dataEl.textContent);
    const gallery = initGallery(root, data);
    const form = $('form[data-fc-product-form]', root);
    const idInput = form && $('input[name="id"]', form);
    const priceEl = $('[data-fc-price]', root);
    const unitEl = $('[data-fc-unit]', root);
    const servingEl = $('[data-fc-serving]', root);
    const submit = form && $('[type="submit"]', form);
    const mhdEl = $('[data-fc-mhd]', root);
    const mhdDate = $('[data-fc-mhd-date]', root);
    const skuEl = $('[data-fc-sku]', root);
    const stockEl = $('[data-fc-stock]', root);
    const optionInputs = $$('[data-fc-option]', root);
    const selectedLabels = $$('[data-fc-option-label]', root);

    function currentOptions() {
      return data.options.map((name, i) => {
        const checked = optionInputs.find((inp) => inp.dataset.fcOption === String(i) && (inp.type === 'radio' ? inp.checked : true));
        return checked ? checked.value : null;
      });
    }

    function findVariant(opts) {
      return data.variants.find((v) => v.options.every((o, i) => o === opts[i]));
    }

    // Preis an jeder Sorte (Buttons und Sortenliste), passend zu den übrigen gewählten Optionen
    function variantPriceHtml(v) {
      if (!v) return '';
      const sale = v.compare_at_price && v.compare_at_price > v.price;
      return `<span>${formatMoney(v.price, data.money_format)}</span>` + (sale ? `<s>${formatMoney(v.compare_at_price, data.money_format)}</s>` : '');
    }

    function updateAvailability(opts) {
      optionInputs.filter((inp) => inp.type === 'radio').forEach((inp) => {
        const i = parseInt(inp.dataset.fcOption, 10);
        const test = opts.slice();
        test[i] = inp.value;
        const v = findVariant(test);
        const label = root.querySelector(`label[for="${inp.id}"]`);
        if (label) label.classList.toggle('is-unavailable', !v || !v.available);
        root.querySelectorAll(`label[for="${inp.id}"] [data-fc-vprice]`).forEach((el) => {
          el.innerHTML = variantPriceHtml(v);
          el.classList.toggle('fc-vprice--sale', !!(v && v.compare_at_price && v.compare_at_price > v.price));
        });
      });
    }

    function render(variant) {
      if (!variant) {
        if (submit) { submit.disabled = true; submit.querySelector('[data-fc-cta-label]').textContent = strings.unavailable || 'Nicht verfügbar'; }
        return;
      }
      if (idInput) idInput.value = variant.id;
      if (priceEl) {
        const onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
        priceEl.className = 'fc-price' + (onSale ? ' fc-price--sale' : '');
        priceEl.innerHTML = formatMoney(variant.price, data.money_format) + (onSale ? ` <s>${formatMoney(variant.compare_at_price, data.money_format)}</s>` : '');
      }
      if (unitEl) {
        unitEl.textContent = variant.unit_price_text || '';
        unitEl.hidden = !variant.unit_price_text;
      }
      if (servingEl) {
        if (variant.servings && variant.servings > 0) {
          servingEl.textContent = `${formatMoney(Math.round(variant.price / variant.servings), data.money_format)} ${servingEl.dataset.suffix || ''}`;
          servingEl.hidden = false;
        } else {
          servingEl.hidden = true;
        }
      }
      if (skuEl) skuEl.textContent = variant.sku || '';
      if (stockEl) {
        const st = variant.stock || (variant.available ? 'in' : 'out');
        stockEl.className = 'fc-stock fc-stock--' + st;
        const txt = st === 'low' ? (stockEl.dataset.low || '').replace('[n]', variant.stock_n) : (st === 'out' ? stockEl.dataset.out : stockEl.dataset.in);
        const out = $('[data-fc-stock-text]', stockEl);
        if (out) out.textContent = txt;
      }
      if (submit) {
        submit.disabled = !variant.available;
        const label = submit.querySelector('[data-fc-cta-label]');
        if (label) label.textContent = variant.available ? (strings.addToCart || 'In den Warenkorb') : (strings.soldOut || 'Ausverkauft');
      }
      if (mhdEl) {
        const show = shouldShowMhd(variant);
        mhdEl.hidden = !show;
        if (show && mhdDate) mhdDate.textContent = variant.mhd;
      }
      selectedLabels.forEach((el) => {
        const i = parseInt(el.dataset.fcOptionLabel, 10);
        el.textContent = variant.options[i] || '';
      });
      // Auswahl (Buttons und Sortenfenster) immer auf die gezeigte Sorte setzen, sonst bleibt eine andere Sorte markiert
      optionInputs.forEach((inp) => {
        if (inp.type !== 'radio') return;
        const an = inp.value === variant.options[parseInt(inp.dataset.fcOption, 10)];
        if (inp.checked !== an) inp.checked = an;
        if (an) $$(`label[for="${inp.id}"][data-fc-sheet-item]`, root).forEach((item) => {
          $$('[data-fc-sheet-item]', item.parentElement).forEach((o) => o.classList.toggle('is-selected', o === item));
        });
      });
      if (gallery) gallery.zeigeSorte(variant);
      document.dispatchEvent(new CustomEvent('fc:variant', { detail: { id: variant.id } }));
      if (data.update_url !== false) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    optionInputs.forEach((inp) => inp.addEventListener('change', () => {
      const opts = currentOptions();
      updateAvailability(opts);
      render(findVariant(opts));
    }));

    const initial = data.variants.find((v) => v.id === data.selected_variant_id) || data.variants[0];
    if (initial) {
      updateAvailability(initial.options);
      const prevUpdate = data.update_url;
      data.update_url = false;
      render(initial);
      data.update_url = prevUpdate;
    }
  });

  /* ---------- Kollektion: Filter & Sortierung ---------- */
  $$('[data-fc-facets-form]').forEach((form) => {
    form.addEventListener('change', (e) => {
      if (e.target.matches('input[type="checkbox"], select')) form.requestSubmit ? form.requestSubmit() : form.submit();
    });
  });
  $$('[data-fc-range]').forEach((box) => {
    const max = parseFloat(box.dataset.max) || 1;
    const cur = box.dataset.currency || 'CHF';
    const a = $('[data-fc-range-min]', box);
    const b = $('[data-fc-range-max]', box);
    const fill = $('[data-fc-range-fill]', box);
    const outA = $('[data-fc-range-out-min]', box);
    const outB = $('[data-fc-range-out-max]', box);
    const hA = $('[data-fc-range-hmin]', box);
    const hB = $('[data-fc-range-hmax]', box);
    const paint = (changed) => {
      let lo = parseFloat(a.value);
      let hi = parseFloat(b.value);
      if (lo > hi) {
        if (changed === a) { lo = hi; a.value = lo; } else { hi = lo; b.value = hi; }
      }
      fill.style.left = (lo / max * 100) + '%';
      fill.style.right = (100 - hi / max * 100) + '%';
      outA.textContent = `${cur} ${lo}`;
      outB.textContent = `${cur} ${hi}`;
    };
    const commit = () => {
      const lo = parseFloat(a.value);
      const hi = parseFloat(b.value);
      hA.value = lo > 0 ? lo : '';
      hB.value = hi < max ? hi : '';
      const form = box.closest('form');
      if (form) form.requestSubmit ? form.requestSubmit() : form.submit();
    };
    [a, b].forEach((inp) => {
      inp.addEventListener('input', () => paint(inp));
      inp.addEventListener('change', commit);
    });
    paint();
  });
  $$('[data-fc-filter-toggle]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const target = document.getElementById(btn.getAttribute('aria-controls'));
      if (!target) return;
      const open = !target.classList.contains('is-open');
      target.classList.toggle('is-open', open);
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

  /* ---------- Lebensmittelinfos: am Computer offen, auf dem Handy zugeklappt ---------- */
  $$('[data-fc-open-desktop]').forEach((root) => {
    const desktop = window.matchMedia('(min-width: 861px)').matches;
    const alle = $$('details', root);
    alle.forEach((d) => {
      // je Sortenblock der erste Abschnitt, damit ein Geschmack mit eigenen Angaben gleich aussieht wie der Standard
      const block = d.closest('[data-fc-sorte]');
      const erster = block ? $('details', block) === d : d === alle[0];
      d.open = desktop && (erster || d.classList.contains('fc-info--label') || d.classList.contains('fc-info--mode'));
    });
  });

  /* ---------- Trennstriche nur zwischen aufklappbaren Zeilen (Wilhelm 30.10.2026: «wenn ein aufklappbarer oben alleine steht,
     soll der Trennstrich weg»): die erste sichtbare Zeile jeder Spalte (am Handy des ganzen Abschnitts) bekommt keinen Strich ---------- */
  const ersteZeile = () => $$('.fc-wi__grid').forEach((grid) => {
    const handy = window.matchMedia('(max-width: 860px)').matches;
    const spalten = handy ? [grid] : Array.from(grid.children);
    $$('.fc-info', grid).forEach((d) => d.classList.remove('is-erste'));
    spalten.forEach((sp) => {
      const erste = (sp.matches && sp.matches('.fc-info') ? [sp] : $$('.fc-info', sp)).find((d) => d.getClientRects().length > 0);
      if (erste) erste.classList.add('is-erste');
    });
  });
  ersteZeile();
  document.addEventListener('fc:variant', () => setTimeout(ersteZeile, 0));
  let ezT;
  window.addEventListener('resize', () => { clearTimeout(ezT); ezT = setTimeout(ersteZeile, 150); });

  /* ---------- Lange Beschreibung kürzen ---------- */
  $$('[data-fc-clamp]').forEach((box) => {
    const btn = box.parentElement.querySelector('[data-fc-clamp-btn]');
    if (!btn) return;
    if (box.scrollHeight <= box.clientHeight + 40) {
      box.classList.add('is-open');
      return;
    }
    btn.hidden = false;
    btn.addEventListener('click', () => {
      const open = !box.classList.contains('is-open');
      box.classList.toggle('is-open', open);
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      btn.textContent = open ? btn.dataset.less : btn.dataset.more;
    });
  });

  /* ---------- Empfehlungen (Oft zusammen gekauft, Ähnliche Produkte) ---------- */
  async function loadReco(el, url, fallback) {
    try {
      const res = await fetch(url);
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const inner = doc.querySelector('[data-fc-reco-inner]');
      if (inner && inner.children.length) {
        el.querySelector('[data-fc-reco-inner]').replaceWith(inner);
        el.hidden = false;
      } else if (fallback) {
        loadReco(el, fallback, null);
      }
    } catch (err) { /* ohne Empfehlungen weiter */ }
  }
  $$('[data-fc-reco]').forEach((el) => {
    if (el.querySelector('[data-fc-reco-inner]').children.length) return;
    loadReco(el, el.getAttribute('data-fc-reco'), el.getAttribute('data-fc-reco-fallback'));
  });

  /* ---------- Warenkorbseite: Menge ändern sendet Formular ---------- */
  $$('form[data-fc-cart-form]').forEach((form) => {
    form.addEventListener('change', (e) => {
      if (e.target.matches('input[name="updates[]"]')) form.submit();
    });
  });

  /* ---------- Produktseite: Eigenschaften «+N», Sorten-Liste (Handy), mitlaufende Kaufleiste ---------- */
  document.addEventListener('click', (e) => {
    const more = e.target.closest('[data-fc-props-more]');
    if (!more) return;
    const list = more.closest('[data-fc-props]');
    if (list) { list.classList.add('is-open'); more.setAttribute('aria-expanded', 'true'); }
  });

  $$('[data-fc-product]').forEach((root) => {
    // Sorten-Liste als Fenster von unten
    $$('[data-fc-sheet-open]', root).forEach((btn) => {
      const sheet = document.getElementById(btn.getAttribute('data-fc-sheet-open'));
      if (!sheet || typeof sheet.showModal !== 'function') return;
      const close = () => { if (sheet.open) sheet.close(); };
      btn.addEventListener('click', () => {
        $$('img[loading="lazy"]', sheet).forEach((img) => { img.loading = 'eager'; });
        sheet.showModal();
        document.documentElement.classList.add('fc-lock');
        const sel = $('.is-selected', sheet);
        if (sel) sel.scrollIntoView({ block: 'center' });
      });
      sheet.addEventListener('close', () => document.documentElement.classList.remove('fc-lock'));
      $$('[data-fc-sheet-close]', sheet).forEach((x) => x.addEventListener('click', close));
      sheet.addEventListener('click', (e) => { if (e.target === sheet) close(); });
      $$('[data-fc-sheet-item]', sheet).forEach((item) => item.addEventListener('click', () => setTimeout(close, 120)));
    });
    // gewählte Sorte in Liste und Auswahlfeld markieren
    $$('[data-fc-option]', root).forEach((inp) => inp.addEventListener('change', () => {
      if (!inp.checked) return;
      $$(`label[for="${inp.id}"][data-fc-sheet-item]`, root).forEach((item) => {
        $$('[data-fc-sheet-item]', item.parentElement).forEach((o) => o.classList.toggle('is-selected', o === item));
        const img = $('img', item);
        const slot = $(`[data-fc-option-img="${inp.dataset.fcOption}"]`, root);
        if (img && slot) slot.innerHTML = `<img src="${img.currentSrc || img.src}" alt="" loading="lazy">`;
      });
    }));

    // Kaufleiste (nur Handy per CSS): erscheint, sobald der Warenkorb-Button oben aus dem Bild ist
    const bar = $('[data-fc-stickybuy]', root);
    const row = $('.fc-cartrow', root);
    const form = $('form[data-fc-product-form]', root);
    const submit = form && $('[type="submit"]', form);
    const price = $('[data-fc-price]', root);
    if (bar && row && form && submit && 'IntersectionObserver' in window) {
      const barPrice = $('[data-fc-sticky-price]', bar);
      const barBtn = $('[data-fc-sticky-add]', bar);
      const barLabel = $('[data-fc-sticky-label]', bar);
      const sync = () => {
        if (barPrice && price) {
          barPrice.innerHTML = price.innerHTML;
          barPrice.classList.toggle('is-sale', price.classList.contains('fc-price--sale') || !!price.querySelector('.fc-price--sale'));
        }
        barBtn.disabled = submit.disabled;
        const l = $('[data-fc-cta-label]', submit);
        if (barLabel && l) barLabel.textContent = l.textContent;
      };
      new MutationObserver(sync).observe(submit, { attributes: true, childList: true, subtree: true });
      if (price) new MutationObserver(sync).observe(price, { childList: true, subtree: true, characterData: true });
      new IntersectionObserver(([en]) => {
        const show = !en.isIntersecting && en.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', show);
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
        barBtn.tabIndex = show ? 0 : -1;
      }).observe(row);
      barBtn.addEventListener('click', () => {
        if (submit.disabled) { row.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
        if (form.requestSubmit) form.requestSubmit(submit); else submit.click();
      });
      sync();
    }
  });

  /* ---------- Produktseite: Lieferdatum mit Bestellschluss (Schweizer Zeit, Wochenende und Feiertage ohne Versand) ---------- */
  $$('[data-fc-eta]').forEach((el) => {
    const cfgEl = el.closest('[data-fc-product]') && $('script[data-fc-eta-config]', el.closest('[data-fc-product]'));
    if (!cfgEl) return;
    let cfg; try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
    const t = cfg.t || {};
    const cutoff = Number(cfg.cutoff) || 18;
    const frei = new Set((cfg.holidays || []).map((x) => String(x).trim()).filter(Boolean));
    const main = $('[data-fc-eta-main]', el);
    const sub = $('[data-fc-eta-sub]', el);
    const fill = (s, v) => String(s || '').replace(/\[(\w+)\]/g, (m, k) => (k in v ? v[k] : m));
    const ymd = (d) => d.toISOString().slice(0, 10);
    const versandtag = (d) => { const w = d.getUTCDay(); return w !== 0 && w !== 6 && !frei.has(ymd(d)); };
    const naechster = (d) => { const x = new Date(d.getTime()); do { x.setUTCDate(x.getUTCDate() + 1); } while (!versandtag(x)); return x; };
    const datum = (d) => fill(t.date, { weekday: t.days[d.getUTCDay()], day: d.getUTCDate(), month: t.months[d.getUTCMonth()] });
    const update = () => {
      let p;
      try {
        p = Object.fromEntries(new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Zurich', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }).formatToParts(new Date()).map((x) => [x.type, x.value]));
      } catch (e) { return; }
      const heute = new Date(Date.UTC(+p.year, +p.month - 1, +p.day));
      const jetzt = (+p.hour) * 60 + (+p.minute);
      const schluss = versandtag(heute) && jetzt < cutoff * 60 ? heute : naechster(heute);
      const liefer = naechster(schluss);
      const tage = Math.round((liefer - heute) / 86400000);
      main.textContent = tage === 1 ? `${t.tomorrow}, ${datum(liefer)}` : fill(t.on, { date: datum(liefer) });
      if (schluss.getTime() === heute.getTime()) {
        const rest = cutoff * 60 - jetzt;
        const h = Math.floor(rest / 60); const m = rest % 60;
        const zeit = (h ? `${h} ${t.hours} ` : '') + `${m} ${t.minutes}`;
        sub.innerHTML = fill(t.order_within, { time: `<b class="fc-eta__time">${zeit}</b>` });
      } else {
        sub.innerHTML = fill(t.order_until, { day: t.days[schluss.getUTCDay()], hour: cutoff });
      }
    };
    update();
    setInterval(update, 30000);
  });

  /* ---------- Produktseite: Klick aufs Bild öffnet die Galerie mit Zoom (window.fcLightbox, unten) ---------- */
  $$('[data-fc-product]').forEach((root) => {
    const alt = $('[data-fc-lb]', root); if (alt) alt.remove();
    // Im Zoom nur die Bilder der gewählten Sorte (sichtbare Folien in ihrer Reihenfolge), Wilhelm 31.10.2026
    const sichtbar = () => $$('[data-fc-slide]:not([hidden])', root).map((s) => ({ s, img: s.querySelector('img') })).filter((b) => b.img && !b.s.querySelector('video, iframe, model-viewer'));
    $$('[data-fc-slide]', root).forEach((slide) => {
      if (!slide.querySelector('img') || slide.querySelector('video, iframe, model-viewer')) return;
      slide.style.cursor = 'zoom-in';
      slide.addEventListener('click', (e) => {
        if (e.target.closest('button, video, iframe, a') || !window.fcLightbox) return;
        const bilder = sichtbar();
        const i = Math.max(0, bilder.findIndex((b) => b.s === slide));
        window.fcLightbox.open(bilder.map((x) => ({ img: x.img })), i, {
          titel: ($('.fc-ptitle') || {}).textContent || '',
          onClose: (k) => { const m = bilder[k] && bilder[k].s.getAttribute('data-fc-media-id'); if (m) root.dispatchEvent(new CustomEvent('fc:gallery-show', { detail: m })); }
        });
      });
    });
  });
})();

/* ---------- Cookie-Banner von Shopify: Schweizer Schreibweise, ss statt ß (Wilhelm 29.10.2026) ----------
   Die Texte des Banners und der Cookie-Einstellungen kommen von Shopify (Deutsch für Deutschland) und lassen sich
   nicht alle in den Einstellungen ändern. Darum hier nur im Banner jedes ß durch ss ersetzen. */
(() => {
  const BANNER = '[id^="shopify-pc"]';
  const ersetzen = (root) => {
    if (!root) return;
    if (root.nodeType === 3) {
      if (root.nodeValue.includes('ß')) root.nodeValue = root.nodeValue.replace(/ß/g, 'ss');
      return;
    }
    const w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    for (let n = w.nextNode(); n; n = w.nextNode()) {
      if (n.nodeValue.includes('ß')) n.nodeValue = n.nodeValue.replace(/ß/g, 'ss');
    }
  };
  const imBanner = (n) => {
    const el = n.nodeType === 1 ? n : n.parentElement;
    return !!(el && el.closest && el.closest(BANNER));
  };
  const start = () => {
    document.querySelectorAll(BANNER).forEach(ersetzen);
    new MutationObserver((liste) => {
      liste.forEach((m) => {
        if (m.type === 'characterData') {
          if (imBanner(m.target)) ersetzen(m.target);
          return;
        }
        m.addedNodes.forEach((n) => {
          if (imBanner(n)) ersetzen(n);
          else if (n.nodeType === 1 && n.querySelectorAll) n.querySelectorAll(BANNER).forEach(ersetzen);
        });
      });
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
  };
  if (document.body) start();
  else document.addEventListener('DOMContentLoaded', start);
})();

/* ---------- Galerie für Produkt- und Rezeptbilder (Wilhelm 30.10.2026: «wie in einem normalen Shop», mit Zoom und schnell) ----------
   Zeigt sofort das schon geladene Bild und lädt die scharfe Fassung sowie die Nachbarbilder im Voraus. Wischen und Pfeile zum Blättern,
   Vorschaubilder unten. Zoom: am Computer Klick aufs Bild (danach folgt der Ausschnitt der Maus), am Handy Doppeltipp oder zwei Finger. */
(() => {
  const S = window.fcStrings || {};
  const svg = (p, s = 22) => `<svg width="${s}" height="${s}" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">${p}</svg>`;
  const ICON = {
    close: svg('<path d="M6 6l12 12M18 6L6 18"/>'),
    prev: svg('<path d="M19 12H5"/><path d="M11 6l-6 6 6 6"/>'),
    next: svg('<path d="M5 12h14"/><path d="M13 6l6 6-6 6"/>'),
    zin: svg('<circle cx="11" cy="11" r="7"/><path d="M20 20l-4-4M11 8v6M8 11h6"/>', 20),
    zout: svg('<circle cx="11" cy="11" r="7"/><path d="M20 20l-4-4M8 11h6"/>', 20)
  };
  const mitBreite = (src, w) => { try { const u = new URL(src, location.href); u.searchParams.set('width', String(w)); u.searchParams.delete('height'); u.searchParams.delete('crop'); return u.toString(); } catch (e) { return src; } };
  const stufe = (w) => Math.min(4000, Math.max(400, Math.ceil(w / 200) * 200));
  const dpr = () => Math.min(3, window.devicePixelRatio || 1);
  const MAXZOOM = 4; const KLICKZOOM = 2.5;

  let box = null; let el = {}; let bilder = []; let index = 0; let opts = {}; let zuletzt = null;
  let z = { s: 1, x: 0, y: 0 };

  function bauen() {
    box = document.createElement('div');
    box.className = 'fc-lbx'; box.hidden = true;
    box.setAttribute('role', 'dialog'); box.setAttribute('aria-modal', 'true');
    box.innerHTML = `<div class="fc-lbx__bar"><span class="fc-lbx__count" aria-live="polite"></span><div class="fc-lbx__tools">`
      + `<button type="button" class="fc-lbx__btn" data-lbx-zoom aria-label="${S.lbZoom || 'Zoom'}">${ICON.zin}</button>`
      + `<button type="button" class="fc-lbx__btn" data-lbx-close aria-label="${S.lbClose || 'Schliessen'}">${ICON.close}</button></div></div>`
      + `<div class="fc-lbx__stage"><div class="fc-lbx__track"></div>`
      + `<button type="button" class="fc-lbx__btn fc-lbx__nav fc-lbx__nav--prev" data-lbx-prev aria-label="${S.lbPrev || 'Zurück'}">${ICON.prev}</button>`
      + `<button type="button" class="fc-lbx__btn fc-lbx__nav fc-lbx__nav--next" data-lbx-next aria-label="${S.lbNext || 'Weiter'}">${ICON.next}</button></div>`
      + `<p class="fc-lbx__cap"></p><div class="fc-lbx__thumbs"></div>`;
    document.body.appendChild(box);
    const q = (s) => box.querySelector(s);
    el = { track: q('.fc-lbx__track'), stage: q('.fc-lbx__stage'), count: q('.fc-lbx__count'), cap: q('.fc-lbx__cap'), thumbs: q('.fc-lbx__thumbs'), zoom: q('[data-lbx-zoom]'), close: q('[data-lbx-close]') };
    q('[data-lbx-prev]').addEventListener('click', () => geh(index - 1));
    q('[data-lbx-next]').addEventListener('click', () => geh(index + 1));
    el.close.addEventListener('click', schliessen);
    el.zoom.addEventListener('click', () => { if (z.s > 1) zuruecksetzen(true); else zoomAuf(KLICKZOOM, null, true); });
    document.addEventListener('keydown', (e) => {
      if (!box || box.hidden) return;
      if (e.key === 'Escape') { e.preventDefault(); if (z.s > 1) zuruecksetzen(true); else schliessen(); }
      else if (e.key === 'ArrowLeft') geh(index - 1);
      else if (e.key === 'ArrowRight') geh(index + 1);
      else if (e.key === 'Tab') {
        const f = [...box.querySelectorAll('button')].filter((b) => b.offsetParent);
        const a = f.indexOf(document.activeElement);
        if (e.shiftKey && a <= 0) { e.preventDefault(); f[f.length - 1].focus(); } else if (!e.shiftKey && a === f.length - 1) { e.preventDefault(); f[0].focus(); }
      }
    });
    window.addEventListener('resize', () => { if (!box.hidden) { zuruecksetzen(false); spur(0, false); } });
    gesten();
  }

  const aktImg = () => el.track.children[index] && el.track.children[index].querySelector('img');
  function spur(dx, glatt) {
    el.track.classList.toggle('is-glatt', !!glatt);
    el.track.style.transform = `translate3d(calc(${-index * 100}% + ${dx}px), 0, 0)`;
  }
  function grenzen(s, x, y) {
    const img = aktImg(); const slide = img && img.parentElement;
    if (!img || !slide) return { x: 0, y: 0 };
    const mx = Math.max(0, (img.offsetWidth * s - slide.clientWidth) / 2);
    const my = Math.max(0, (img.offsetHeight * s - slide.clientHeight) / 2);
    return { x: Math.max(-mx, Math.min(mx, x)), y: Math.max(-my, Math.min(my, y)) };
  }
  function zeichnen(glatt) {
    const img = aktImg(); if (!img) return;
    img.classList.toggle('is-glatt', !!glatt);
    img.style.transform = z.s === 1 ? '' : `translate3d(${z.x}px, ${z.y}px, 0) scale(${z.s})`;
    box.classList.toggle('is-zoom', z.s > 1);
    el.zoom.innerHTML = z.s > 1 ? ICON.zout : ICON.zin;
  }
  function scharf(i, faktor) {
    const b = bilder[i]; const img = el.track.children[i] && el.track.children[i].querySelector('img');
    if (!b || !img) return;
    const slide = img.parentElement;
    const w = stufe((slide.clientWidth || window.innerWidth) * dpr() * (faktor || 1));
    if ((b.geladen || 0) >= w) return;
    b.geladen = w;
    const hi = new Image();
    hi.onload = () => { img.src = hi.src; };
    hi.src = mitBreite(b.src, w);
  }
  // Zoom auf Stufe s um einen Punkt am Bildschirm (ohne Punkt: Mitte)
  function zoomAuf(s, punkt, glatt) {
    const img = aktImg(); if (!img) return;
    const r = img.parentElement.getBoundingClientRect();
    const px = punkt ? punkt.x - (r.left + r.width / 2) : 0;
    const py = punkt ? punkt.y - (r.top + r.height / 2) : 0;
    const s0 = z.s;
    s = Math.max(1, Math.min(MAXZOOM, s));
    const x = px - (s * (px - z.x)) / s0; const y = py - (s * (py - z.y)) / s0;
    z = { s, ...grenzen(s, x, y) };
    if (s > 1) scharf(index, Math.min(s, 2.5));
    zeichnen(glatt);
  }
  function zuruecksetzen(glatt) { z = { s: 1, x: 0, y: 0 }; zeichnen(glatt); }

  function geh(i, sofort) {
    if (!bilder.length) return;
    const n = (i + bilder.length) % bilder.length;
    if (z.s > 1) zuruecksetzen(false);
    index = n;
    spur(0, !sofort);
    el.count.textContent = bilder.length > 1 ? `${n + 1} / ${bilder.length}` : '';
    el.cap.textContent = bilder[n].cap || '';
    [...el.thumbs.children].forEach((t, k) => t.setAttribute('aria-current', k === n ? 'true' : 'false'));
    const at = el.thumbs.children[n]; if (at) at.scrollIntoView({ block: 'nearest', inline: 'center' });
    [n, n + 1, n - 1].forEach((k) => scharf((k + bilder.length) % bilder.length));
  }

  function gesten() {
    const st = el.stage; const p = new Map();
    let start = null; let bewegt = false; let tap = { t: 0, x: 0, y: 0 }; let zieh = 0;
    const abst = (a, b) => Math.hypot(a.x - b.x, a.y - b.y);
    st.addEventListener('pointerdown', (e) => {
      if (e.target.closest('button')) return;
      try { st.setPointerCapture(e.pointerId); } catch (err) { /* ohne Erfassung */ }
      p.set(e.pointerId, { x: e.clientX, y: e.clientY, typ: e.pointerType });
      if (p.size === 1) { start = { x: e.clientX, y: e.clientY, zx: z.x, zy: z.y, aufBild: !!(e.target.classList && e.target.classList.contains('fc-lbx__img')) }; bewegt = false; zieh = 0; }
      if (p.size === 2) { const [a, b] = [...p.values()]; start = { pinch: true, d0: abst(a, b), s0: z.s, zx: z.x, zy: z.y }; bewegt = true; }
    });
    st.addEventListener('pointermove', (e) => {
      // Maus ohne gedrückte Taste: im Zoom folgt der Ausschnitt der Maus
      if (e.pointerType === 'mouse' && !p.size) {
        if (z.s > 1) {
          const img = aktImg(); const r = img.parentElement.getBoundingClientRect();
          const mx = Math.max(0, (img.offsetWidth * z.s - r.width) / 2); const my = Math.max(0, (img.offsetHeight * z.s - r.height) / 2);
          z.x = mx * (1 - 2 * (e.clientX - r.left) / r.width); z.y = my * (1 - 2 * (e.clientY - r.top) / r.height);
          zeichnen(false);
        }
        return;
      }
      if (!p.has(e.pointerId) || !start) return;
      p.set(e.pointerId, { x: e.clientX, y: e.clientY, typ: e.pointerType });
      if (start.pinch && p.size >= 2) {
        const [a, b] = [...p.values()];
        const s = Math.max(1, Math.min(MAXZOOM, start.s0 * abst(a, b) / start.d0));
        z.s = start.s0; z.x = start.zx; z.y = start.zy;
        zoomAuf(s, { x: (a.x + b.x) / 2, y: (a.y + b.y) / 2 }, false);
        return;
      }
      const dx = e.clientX - start.x; const dy = e.clientY - start.y;
      if (Math.abs(dx) > 6 || Math.abs(dy) > 6) bewegt = true;
      if (z.s > 1) {
        if (e.pointerType !== 'mouse') { const g = grenzen(z.s, start.zx + dx, start.zy + dy); z.x = g.x; z.y = g.y; zeichnen(false); }
      } else if (bilder.length > 1 && Math.abs(dx) > Math.abs(dy)) {
        zieh = dx; spur(dx, false);
      }
    });
    const ende = (e) => {
      if (!p.has(e.pointerId)) return;
      p.delete(e.pointerId);
      if (!start) return;
      if (start.pinch) { if (p.size === 0) { if (z.s < 1.08) zuruecksetzen(true); start = null; } return; }
      const w = el.stage.clientWidth || 1;
      if (z.s === 1 && bewegt && Math.abs(zieh) > Math.min(80, w * 0.15)) geh(index + (zieh < 0 ? 1 : -1));
      else if (z.s === 1 && zieh) spur(0, true);
      if (!bewegt && e.type === 'pointerup') {
        // Ziel vom Drücken nehmen: wegen setPointerCapture kommt pointerup sonst am Rahmen an und der Klick schloss den Zoom (Wilhelm 31.10.2026)
        const aufBild = start.aufBild;
        if (e.pointerType === 'mouse') {
          if (z.s > 1) zuruecksetzen(true);
          else if (aufBild) zoomAuf(KLICKZOOM, { x: e.clientX, y: e.clientY }, true);
          else schliessen();
        } else {
          const jetzt = Date.now();
          if (jetzt - tap.t < 320 && Math.hypot(e.clientX - tap.x, e.clientY - tap.y) < 30) {
            if (z.s > 1) zuruecksetzen(true); else zoomAuf(KLICKZOOM, { x: e.clientX, y: e.clientY }, true);
            tap.t = 0;
          } else tap = { t: jetzt, x: e.clientX, y: e.clientY };
        }
      }
      start = null; zieh = 0;
    };
    st.addEventListener('pointerup', ende);
    st.addEventListener('pointercancel', ende);
    st.addEventListener('wheel', (e) => {
      if (!(e.ctrlKey || z.s > 1)) return;
      e.preventDefault();
      zoomAuf(z.s * (e.deltaY < 0 ? 1.15 : 1 / 1.15), { x: e.clientX, y: e.clientY }, false);
      if (z.s < 1.02) zuruecksetzen(false);
    }, { passive: false });
  }

  function oeffnen(liste, start, o) {
    if (!box) bauen();
    opts = o || {};
    bilder = liste.map((b) => ({ src: b.src || (b.img && (b.img.currentSrc || b.img.src)) || '', klein: b.img ? (b.img.currentSrc || b.img.src) : b.src, alt: b.alt || (b.img && b.img.alt) || '', cap: b.cap || '', geladen: 0 })).filter((b) => b.src);
    if (!bilder.length) return;
    box.classList.toggle('fc-lbx--dunkel', !!opts.dunkel);
    box.classList.toggle('is-single', bilder.length < 2);
    box.setAttribute('aria-label', opts.titel || S.lbGallery || '');
    el.track.innerHTML = bilder.map((b) => `<div class="fc-lbx__slide"><img class="fc-lbx__img" src="${b.klein}" alt="${String(b.alt).replace(/"/g, '&quot;')}" draggable="false"></div>`).join('');
    el.thumbs.innerHTML = bilder.length < 2 ? '' : bilder.map((b, i) => `<button type="button" class="fc-lbx__thumb" aria-label="${i + 1} / ${bilder.length}"><img src="${b.klein}" alt="" draggable="false"></button>`).join('');
    [...el.thumbs.children].forEach((t, i) => t.addEventListener('click', () => geh(i)));
    zuletzt = document.activeElement;
    z = { s: 1, x: 0, y: 0 };
    box.hidden = false;
    document.documentElement.classList.add('fc-lbx-offen');
    index = Math.max(0, Math.min(bilder.length - 1, start || 0));
    geh(index, true);
    zeichnen(false);
    requestAnimationFrame(() => box.classList.add('is-open'));
    el.close.focus({ preventScroll: true });
  }
  function schliessen() {
    if (!box || box.hidden) return;
    box.classList.remove('is-open');
    document.documentElement.classList.remove('fc-lbx-offen');
    const k = index;
    setTimeout(() => { box.hidden = true; el.track.innerHTML = ''; }, 200);
    if (opts.onClose) opts.onClose(k);
    if (zuletzt && zuletzt.focus) zuletzt.focus({ preventScroll: true });
  }
  window.fcLightbox = { open: oeffnen, close: schliessen };
})();
